var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "modal",
        {
          staticClass: "event-modal right-modal custom-modal",
          attrs: {
            name: "customMessageModal",
            width: "50%",
            height: "auto",
            scrollable: true,
            pivotX: 1.0,
            minHeight: 900
          },
          on: { "before-open": _vm.beforeOpen, "before-close": _vm.beforeClose }
        },
        [
          _c("div", { staticClass: "modal-box" }, [
            _c(
              "div",
              {
                staticClass: "overlay",
                class: { isLoading: _vm.isLoading, noDisplay: !_vm.isLoading }
              },
              [
                _c(
                  "div",
                  { staticClass: "spinner-align" },
                  [
                    _c("Icon", {
                      staticClass: "icon-size",
                      attrs: { name: "spinner", scale: "5", pulse: "" }
                    })
                  ],
                  1
                )
              ]
            ),
            _vm._v(" "),
            !_vm.isLoading
              ? _c("div", { staticClass: "main-content" }, [
                  _c(
                    "div",
                    {
                      staticClass: "modal-close-img",
                      on: {
                        click: function($event) {
                          _vm.hideModal()
                        },
                        mouseover: function($event) {
                          _vm.isHoverClose = true
                        },
                        mouseleave: function($event) {
                          _vm.isHoverClose = false
                        }
                      }
                    },
                    [
                      !_vm.isHoverClose
                        ? _c("img", {
                            attrs: {
                              src: require("../../../static/img/info-modal-close.svg"),
                              alt: "close"
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isHoverClose
                        ? _c("img", {
                            attrs: {
                              src: require("../../../static/img/info-modal-close-hover.svg"),
                              alt: "close"
                            }
                          })
                        : _vm._e()
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "modal-title" }, [
                    _vm._v("Client Details")
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "configure-scheduler ap-btn secondary",
                      on: {
                        click: function($event) {
                          _vm.openSchedulerConfig()
                        }
                      }
                    },
                    [_vm._v("\n        CONFIGURE SCHEDULER\n      ")]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "modal-header" }, [
                    _c(
                      "div",
                      { staticClass: "modal-header-text-edit" },
                      [
                        _c("textarea", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.clientName,
                              expression: "clientName"
                            }
                          ],
                          staticClass: "input-client-name",
                          domProps: { value: _vm.clientName },
                          on: {
                            keyup: function($event) {
                              _vm.bIsSaveClientName = true
                            },
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.clientName = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _vm.bIsSaveClientName
                          ? _c(
                              "b-button",
                              {
                                staticClass: "save-client-name-btn",
                                on: {
                                  click: function($event) {
                                    _vm.saveClientName({
                                      clientId: _vm.clientId,
                                      clientName: _vm.clientName
                                    })
                                  }
                                }
                              },
                              [
                                _c("Icon", { attrs: { name: "file-save-o" } }),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "dt-group-btn-func-btn-left-text"
                                  },
                                  [_vm._v("SAVE")]
                                )
                              ],
                              1
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "modal-body main-content" },
                    [
                      _c("CustomMessageSectionSubmission", {
                        attrs: { content: _vm.submissionMessage },
                        on: { UPDATE_MESSAGE: _vm.callSaveMessage }
                      }),
                      _vm._v(" "),
                      _c("CustomMessageSectionChangeOrder", {
                        attrs: { content: _vm.changeOrderMessage },
                        on: { UPDATE_MESSAGE: _vm.callSaveMessage }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "add-on" },
                    [
                      _c("div", { staticClass: "title" }, [
                        _vm._v("\n          Add-on configuration\n        ")
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "description" }, [
                        _vm._v(
                          "\n          Toggle availability of add-on services this client can select when requesting a new event.\n        "
                        )
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.addOns, function(item, index) {
                        return _c(
                          "div",
                          { key: index, staticClass: "add-on-item" },
                          [
                            _c("span", { staticClass: "text" }, [
                              _vm._v(_vm._s(item.text))
                            ]),
                            _vm._v(" "),
                            item.key === "fluShots"
                              ? _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: item.value,
                                      expression: "item.value"
                                    }
                                  ],
                                  attrs: {
                                    type: "checkbox",
                                    id: item.key,
                                    disabled: !_vm.isAdminUser
                                  },
                                  domProps: {
                                    checked: Array.isArray(item.value)
                                      ? _vm._i(item.value, null) > -1
                                      : item.value
                                  },
                                  on: {
                                    change: [
                                      function($event) {
                                        var $$a = item.value,
                                          $$el = $event.target,
                                          $$c = $$el.checked ? true : false
                                        if (Array.isArray($$a)) {
                                          var $$v = null,
                                            $$i = _vm._i($$a, $$v)
                                          if ($$el.checked) {
                                            $$i < 0 &&
                                              _vm.$set(
                                                item,
                                                "value",
                                                $$a.concat([$$v])
                                              )
                                          } else {
                                            $$i > -1 &&
                                              _vm.$set(
                                                item,
                                                "value",
                                                $$a
                                                  .slice(0, $$i)
                                                  .concat($$a.slice($$i + 1))
                                              )
                                          }
                                        } else {
                                          _vm.$set(item, "value", $$c)
                                        }
                                      },
                                      function($event) {
                                        _vm.checkboxToggle(item.key, item.value)
                                      }
                                    ]
                                  }
                                })
                              : _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: item.value,
                                      expression: "item.value"
                                    }
                                  ],
                                  attrs: { type: "checkbox", id: item.key },
                                  domProps: {
                                    checked: Array.isArray(item.value)
                                      ? _vm._i(item.value, null) > -1
                                      : item.value
                                  },
                                  on: {
                                    change: [
                                      function($event) {
                                        var $$a = item.value,
                                          $$el = $event.target,
                                          $$c = $$el.checked ? true : false
                                        if (Array.isArray($$a)) {
                                          var $$v = null,
                                            $$i = _vm._i($$a, $$v)
                                          if ($$el.checked) {
                                            $$i < 0 &&
                                              _vm.$set(
                                                item,
                                                "value",
                                                $$a.concat([$$v])
                                              )
                                          } else {
                                            $$i > -1 &&
                                              _vm.$set(
                                                item,
                                                "value",
                                                $$a
                                                  .slice(0, $$i)
                                                  .concat($$a.slice($$i + 1))
                                              )
                                          }
                                        } else {
                                          _vm.$set(item, "value", $$c)
                                        }
                                      },
                                      function($event) {
                                        _vm.checkboxToggle(item.key, item.value)
                                      }
                                    ]
                                  }
                                }),
                            _c("label", { attrs: { for: item.key } }, [
                              _vm._v("Toggle")
                            ])
                          ]
                        )
                      })
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "secondary-am" }, [
                    _c("div", { staticClass: "title" }, [
                      _vm._v("\n          Secondary Account Manager\n        ")
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "description" }, [
                      _vm._v(
                        "\n          Assign a secondary account manager.\n        "
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "pick custom-multiselect" },
                      [
                        _c("multiselect", {
                          staticClass: "input-second-am",
                          attrs: {
                            options: _vm.listSecondaryAM,
                            placeholder: "Secondary account manager",
                            label: "name",
                            openDirection: "below",
                            multiple: true,
                            "close-on-select": true,
                            "hide-selected": true,
                            "track-by": "id",
                            "allow-empty": true,
                            "show-labels": false
                          },
                          on: {
                            select: _vm.selectSecondaryAM,
                            remove: _vm.removeAM
                          },
                          model: {
                            value: _vm.secondaryAMSelected,
                            callback: function($$v) {
                              _vm.secondaryAMSelected = $$v
                            },
                            expression: "secondaryAMSelected"
                          }
                        })
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "reseller-status" }, [
                    _c("div", { staticClass: "title" }, [
                      _vm._v("\n            Reseller Status\n          ")
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "description" }, [
                      _vm._v(
                        "\n            Toggle client status as a reseller and assign subclients.\n          "
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "reseller-toggle" }, [
                      _c("span", { staticClass: "text" }, [_vm._v("Reseller")]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.resellerToggle,
                            expression: "resellerToggle"
                          }
                        ],
                        attrs: {
                          type: "checkbox",
                          id: "reseller",
                          disabled: _vm.managedByClientId != null
                        },
                        domProps: {
                          checked: Array.isArray(_vm.resellerToggle)
                            ? _vm._i(_vm.resellerToggle, null) > -1
                            : _vm.resellerToggle
                        },
                        on: {
                          change: [
                            function($event) {
                              var $$a = _vm.resellerToggle,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    (_vm.resellerToggle = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.resellerToggle = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.resellerToggle = $$c
                              }
                            },
                            function($event) {
                              _vm.resellerToggleCheck(_vm.resellerToggle)
                            }
                          ]
                        }
                      }),
                      _c("label", { attrs: { for: "reseller" } }, [
                        _vm._v("Toggle")
                      ])
                    ]),
                    _vm._v(" "),
                    _vm.resellerToggle
                      ? _c("div", { staticClass: "read-only custom-toggle" }, [
                          _c("span", { staticClass: "text" }, [
                            _vm._v("Read Only")
                          ]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.readOnlyToggle,
                                expression: "readOnlyToggle"
                              }
                            ],
                            attrs: { type: "checkbox", id: "readOnly" },
                            domProps: {
                              checked: Array.isArray(_vm.readOnlyToggle)
                                ? _vm._i(_vm.readOnlyToggle, null) > -1
                                : _vm.readOnlyToggle
                            },
                            on: {
                              change: [
                                function($event) {
                                  var $$a = _vm.readOnlyToggle,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        (_vm.readOnlyToggle = $$a.concat([$$v]))
                                    } else {
                                      $$i > -1 &&
                                        (_vm.readOnlyToggle = $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1)))
                                    }
                                  } else {
                                    _vm.readOnlyToggle = $$c
                                  }
                                },
                                function($event) {
                                  _vm.readOnlyToggleCheck(_vm.readOnlyToggle)
                                }
                              ]
                            }
                          }),
                          _c("label", { attrs: { for: "readOnly" } }, [
                            _vm._v("Toggle")
                          ])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "pick custom-multiselect" },
                      [
                        _vm.resellerToggle
                          ? _c("multiselect", {
                              staticClass: "input-second-am",
                              attrs: {
                                options: _vm.listSubClient,
                                placeholder: "Search for client to add",
                                label: "clientName",
                                openDirection: "below",
                                "show-no-results": false,
                                multiple: true,
                                "close-on-select": true,
                                "hide-selected": true,
                                "track-by": "clientId",
                                "allow-empty": true,
                                "show-labels": false
                              },
                              on: {
                                select: _vm.selectSubClient,
                                remove: _vm.removeSubClient
                              },
                              model: {
                                value: _vm.subClientSelected,
                                callback: function($$v) {
                                  _vm.subClientSelected = $$v
                                },
                                expression: "subClientSelected"
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "secondary-am" }, [
                    _c("div", { staticClass: "title" }, [
                      _vm._v("\n            Validators\n          ")
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "description" }, [
                      _vm._v(
                        "\n            Assign Validators for clients.\n          "
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "pick last-child-pick custom-multiselect"
                      },
                      [
                        _c("multiselect", {
                          staticClass: "input-second-am",
                          attrs: {
                            options: _vm.listValidators,
                            placeholder: "Choose or select validators",
                            label: "name",
                            openDirection: "below",
                            multiple: true,
                            "close-on-select": true,
                            "hide-selected": true,
                            "track-by": "id",
                            "allow-empty": true,
                            "show-labels": false
                          },
                          on: { select: _vm.addValidators },
                          scopedSlots: _vm._u([
                            {
                              key: "tag",
                              fn: function(props) {
                                return [
                                  _c(
                                    "span",
                                    { staticClass: "multiselect__tag" },
                                    [
                                      _c("span", [
                                        _vm._v(_vm._s(props.option.name))
                                      ]),
                                      _vm._v(" "),
                                      !_vm.readOnlyTaggingValidators(
                                        props.option
                                      )
                                        ? _c("i", {
                                            staticClass:
                                              "multiselect__tag-icon",
                                            attrs: {
                                              "aria-hidden": "true",
                                              tabindex: "1"
                                            },
                                            on: {
                                              click: function($event) {
                                                _vm.removeValidators(
                                                  props.option
                                                )
                                              }
                                            }
                                          })
                                        : _vm._e()
                                    ]
                                  )
                                ]
                              }
                            }
                          ]),
                          model: {
                            value: _vm.selectedValidators,
                            callback: function($$v) {
                              _vm.selectedValidators = $$v
                            },
                            expression: "selectedValidators"
                          }
                        })
                      ],
                      1
                    )
                  ])
                ])
              : _vm._e()
          ])
        ]
      ),
      _vm._v(" "),
      _c("ConfigureSchedulerModal"),
      _vm._v(" "),
      _c("ModalChangeToggleVaccines", {
        attrs: {
          onCheckToggleOnOff: _vm.processUpdateAddons,
          addOns: _vm.addOns,
          nameModal: _vm.modalVaccineChangeConfirmationName,
          textQuestion: _vm.textTurnOffVaccineConfirmation,
          listTextDescription: _vm.textTurnOffVaccineConfirmationDescription
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-42cf7a83", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-42cf7a83","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modal/CustomMessageModal.vue
// module id = 1659
// module chunks = 1